import React from "react";

interface ConnectionSuccessAlertProps {
  message: string;
  onReturnToConnections: () => void;
  onGoHome: () => void;
}

const ConnectionSuccessAlert: React.FC<ConnectionSuccessAlertProps> = ({
  message,
  onReturnToConnections,
  onGoHome,
}) => (
  <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-lg shadow-md">
    <div className="text-center">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          className="w-8 h-8 text-green-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">
        Connection Successful
      </h2>
      <p className="text-gray-600">{message}</p>
    </div>
    <div className="space-y-3">
      <button
        onClick={onReturnToConnections}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 px-4 rounded-md"
      >
        Return to Connections
      </button>
      <button
        onClick={onGoHome}
        className="w-full bg-surface-ui hover:bg-surface-ui-hover text-gray-800 py-3 px-4 rounded-md"
      >
        Go to Home Page
      </button>
    </div>
  </div>
);

export default ConnectionSuccessAlert;
